import { get } from 'Api';
import store from 'Redux/store';

/**
 * Fetch recommendations for "You may also like sections"
 * @param  {String} type              Type of products (game, bundle, dlc)
 * @param  {Array.String} franchises  Array of franchises to search for
 * @return {Array.Object}             Product hits
 */
export default function fetchRecommendations(type, franchises) {
  let url = `/algolia/recommendations/${type === 'dlc' ? 'game' : type}`;

  if (franchises && franchises.length) {
    url += `?franchises=${encodeURI(franchises.join(','))}`;
  } else if (type === 'cart') {
    url = '/algolia/cart-recommendations';
  }

  return get(store.dispatch, url)
    .then(({ response, data }) => {
      if (response && Array.isArray(data) && data.length) {
        return data;
      }
      return [];
    });
}
